export default {
  init() {
    /* eslint-disable no-console */
    // console.log( flickrAPI ); // eslint-disable-line no-undef
    /* eslint-enable no-console */

    // Load photo gallery images from flickr:
    $.ajax({
        // Flickr API is SSL only:
        // https://code.flickr.net/2014/04/30/flickr-api-going-ssl-only-on-june-27th-2014/
        url: 'https://api.flickr.com/services/rest/',
        data: flickrAPI, // eslint-disable-line no-undef
        dataType: 'jsonp',
        jsonp: 'jsoncallback',
    }).done(function (result) {
        var photoGalleryContainer = $('#links'),
            photoMosaicSlots = $('[data-space-mosaic] .gbr-space-mosaic-slot'),
            mosaicPhotoIndex = 0,
            baseUrl;

        /* eslint-disable no-console */
        // Add the images as links with thumbnails to the page:
        // console.log(result);
        /* eslint-enable no-console */

        $.each(result.photoset.photo, function (index, photo) {
            baseUrl = 'https://farm' + photo.farm + '.static.flickr.com/' +
                photo.server + '/' + photo.id + '_' + photo.secret;

            if (photo.isprimary == '1') {
              // main photo, skip
            } else {
              if (mosaicPhotoIndex < photoMosaicSlots.length) {
                $(photoMosaicSlots[mosaicPhotoIndex])
                  .removeClass('is-loading')
                  .empty()
                  .append($('<a/>')
                    .append($('<img>')
                      .attr('loading', 'eager')
                      .attr('decoding', 'async')
                      .attr('alt', photo.title)
                      .prop('src', baseUrl + '_n.jpg'))
                    .prop('href', baseUrl + '_b.jpg')
                    .prop('title', photo.title)
                    .prop('data-pin-nopin', 'true')
                    .attr('data-gallery', ''));

                if (mosaicPhotoIndex === photoMosaicSlots.length - 1) {
                  $(photoMosaicSlots[mosaicPhotoIndex]).append(
                    $('<a/>')
                      .attr('class', 'gbr-space-show-photos')
                      .prop('href', '#space-photo-gallery')
                      .text('Show all photos')
                  );
                }

                mosaicPhotoIndex += 1;
              }

              $('<a/>')
                  .append($('<img>')
                    .attr('class', 'img-responsive')
                    .attr('loading', 'lazy')
                    .attr('decoding', 'async')
                    .prop('src', baseUrl + '_n.jpg'))
                  .prop('href', baseUrl + '_b.jpg')
                  .prop('title', photo.title)
                  .prop('data-pin-nopin', 'true')
                  .attr('data-gallery', '')
                  .appendTo(photoGalleryContainer);
            }
        });
        $( '#links a' ).wrap('<div></div>');
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
